(function() {
  function updatePayPalInstallment() {
    fetch('/cart.js') // Récupère les informations du panier Shopify en direct
      .then(response => response.json())
      .then(cart => {
        const installmentElement = document.getElementById("paypal-installment");
        if (!installmentElement) return; // Sécurité si l'élément n'existe pas encore

        const installmentAmount = cart.total_price / 4 / 100; // Convertit en euros
        const formattedInstallment = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(installmentAmount);

        installmentElement.textContent = formattedInstallment; // Met à jour l'affichage
      })
      .catch(error => console.error("PayPal installment update error:", error));
  }

  function observeCartChanges() {
    document.addEventListener("cart:updated", updatePayPalInstallment); // Écoute Shopify AJAX

    document.body.addEventListener("click", (event) => {
      if (
        event.target.matches(".cart__qty-adjust") ||  // Boutons + et -
        event.target.matches(".cart__remove") ||      // Bouton Supprimer
        event.target.matches("[name='update']")       // Bouton "Mettre à jour"
      ) {
        updatePayPalInstallment();
      }
    });

    // Surveille les changements dynamiques dans le Cart Drawer
    const cartDrawer = document.querySelector("#cart-drawer");
    if (cartDrawer) {
      const observer = new MutationObserver(updatePayPalInstallment);
      observer.observe(cartDrawer, { childList: true, subtree: true });
    }
  }

  // Initialisation lors du chargement de la page
  document.addEventListener("DOMContentLoaded", () => {
    updatePayPalInstallment();
    observeCartChanges();
  });

})();
